import { LayoutSettingsContext } from '@/shared/ui/theme/layoutSettingsStore'
import { DEFAULT_SPIN_ICON } from '@/shared/ui/theme/settings'
import { Spin, type SpinProps } from 'antd'
import { useContext } from 'react'
import { getSpinIndicator } from './spin-icons'

/** Spin AntD (màn công khai): icon theo thiết lập; chưa có context (login, trước provider) dùng mặc định. */
const UiSpin = ({ indicator, ...rest }: SpinProps) => {
  const kind = useContext(LayoutSettingsContext)?.settings.spinIcon ?? DEFAULT_SPIN_ICON
  return <Spin indicator={indicator ?? getSpinIndicator(kind)} {...rest} />
}
export default UiSpin
